import { COLOR_BASE_GREY_40, COLOR_BASE_GREY_60, PAGE_MARGIN_XS } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { transitionDuration, transitionTiming } from '~/styles/tokens';

export type SliderActionStyleProps = {
	navigationLeftPosition: number;
};

export const SliderActionStyle = styled.div<SliderActionStyleProps>`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 8px;

	justify-content: center;

	.asLink {
		cursor: pointer;
	}
`;

export const SliderActionIndicatorStyle = styled.span`
	margin-left: ${PAGE_MARGIN_XS}px;
	margin-right: ${PAGE_MARGIN_XS}px;
`;

export const SliderActionExpandCatalogueStyle = styled.span<SliderActionStyleProps>`
	display: block;
	margin-left: auto;
	margin-right: ${(props) => props.navigationLeftPosition}px;
	color: ${COLOR_BASE_GREY_40};
	transition-timing-function: ${transitionTiming};
	transition-duration: ${transitionDuration}ms;
	transition-property: color;

	@media (hover: hover) {
		&:hover {
			color: ${COLOR_BASE_GREY_60};
		}
	}
`;
